
import React from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = "md" }) => {
  // Size mappings for the spinner
  const sizeClasses = {
    sm: "h-6 w-6 border-t-2 border-b-2",
    md: "h-10 w-10 border-t-2 border-b-2",
    lg: "h-16 w-16 border-t-3 border-b-3"
  };

  const spinnerSizeClass = sizeClasses[size];

  return (
    <div className="flex items-center justify-center">
      <div className={`animate-spin rounded-full ${spinnerSizeClass} border-reagent-blue`}></div>
    </div>
  );
};

export default LoadingSpinner;
